<template>
    <plane-vue-table :showSearchBox="false" title="Order" :fields="fields" :url="listUrl" :per-page="10" ref="table"
                     :page-number="false" :extra-params="user">
        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn color="primary" class="btn-basic-b" size="xs" @click="viewDetails(rowData)" text="View"/>
            </div>
        </template>
    </plane-vue-table>
</template>

<script>
import urls from '../../../../../data/urls';

export default {
    name  : 'ListingComponent',
    props : { user : { type : Number } },
    data () {
        return {
            start_date    : '',
            end_date      : '',
            status        : '',
            listUrl       : urls.salesAdmin.customers.orderList,
            statusOptions : [
                { value : 'Pending', label : 'Pending' },
                { value : 'Processing', label : 'Processing' },
                { value : 'Completed', label : 'Completed' }
            ],
            fields : [
                {
                    name      : '__slot:no',
                    sortField : 'no',
                    title     : 'Sl No'
                },
                {
                    name      : 'id',
                    sortField : 'id',
                    title     : 'Order ID'
                },
                {
                    name      : 'sale_date',
                    sortField : 'sale_date',
                    title     : 'Sale Date'
                },
                {
                    name      : 'sub_total',
                    sortField : 'sub_total',
                    title     : 'Sub Total'
                },
                {
                    name      : 'total_amount',
                    sortField : 'total_amount',
                    title     : 'Total'
                },
                {
                    name      : 'status',
                    sortField : 'status',
                    title     : 'Status'
                },
                {
                    name  : '__slot:actions',
                    title : 'Actions'
                }

            ]
        };
    },
    methods : {
        getSlNo (rowData, items) {
            for (let i = 0; i <= items.length; i++) {
                if (items[i].id === rowData.id) {
                    return i + 1;
                }
            }
        },
        viewDetails (rowData) {
            this.$router.push('/sales/order/' + rowData.id + '/details/');
        }
    }
};
</script>
